<template lang="pug">
div
  #request(v-if="user.role=='manager'")
    el-popover(placement="right" :title="$t('Cuona.Device.title05')" width="200" trigger="hover" :content="$t('Cuona.Device.description03')")
            el-button.question(slot="reference" type="text")
              i.el-icon-question
    el-button(type="info" @click="isShowingDialog=true") {{ $t('Cuona.Device.request_device') }}

  #devices
    el-alert.dirty(type="warning" :title="$t('Cuona.Device.NfcUpdate.multiple_are_dirty')" :closable="false" show-icon v-if="isDirty()")
      el-button(type="warning" @click="updateDevicesNFC" size="mini") {{ $t('Cuona.Device.update')}}
    .content
      DevicesTable.group(:devices="devices" :edit="false" :loading="isLoading")

  RequestProduct(:showing="isShowingDialog")
</template>

<script>
import DevicesTable from '../DevicesTable'
import RequestProduct from '../../RequestProduct'
import { mapState } from 'vuex'
import DeviceApi from '@/api/cuona'
import IotProxyApi from '@/api/iot_proxy'
export default {
  data () {
    return {
      isLoading: true,
      isShowingDialog: false,
      devices: []
    }
  },
  title() {
    return this.$t('menus.devices')
  },
  mounted() {
    this.getDevices();
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  },
  components: { DevicesTable, RequestProduct },
  methods: {

    // デバイス一覧の取得
    getDevices: function (){
      DeviceApi.getDevices()
        .then(devices => {
          this.devices = devices;
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Device.failed_get'),
            type: 'error'
          });
        })
        .finally(() => { this.isLoading = false; });
    },
    isDirty: function () {
      return this.devices.some(function (device){
        return device.device_type === 'cube' && device.status === 'dirty'
      });
    },
    updateDevicesNFC: function () {
      this.isLoading = true;
      IotProxyApi.updateNfcAll()
        .then(res => {
          const anySuccess = res.results.some(i => i.status === 'success');
          const anyFailure = res.results.some(i => i.status !== 'success');
          if (anySuccess && !anyFailure) {
            this.$message({
              showClose: true,
              message: this.$t('Cuona.Device.NfcUpdate.multiple_updated_successfully'),
              type: 'success'
            })
          }
          if (anySuccess && anyFailure) {
            this.$message({
              showClose: true,
              message: this.$t('Cuona.Device.NfcUpdate.multiple_partially_updated'),
              type: 'warning'
            })
          }
          if (!anySuccess && anyFailure) {
            this.$message({
              showClose: true,
              message: this.$t('Cuona.Device.NfcUpdate.multiple_update_failed'),
              type: 'error'
            })
          }
          if (!anySuccess && !anyFailure) { // no devices needed update
            this.$message({
              showClose: true,
              message: this.$t('Cuona.Device.NfcUpdate.multiple_nothing_to_update'),
              type: 'notification'
            })
          }
        }).catch((e) => {
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Device.nfc_update_all_request_failed'),
            type: 'error'
          })
      }).finally(() => this.getDevices())
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables.scss";
@import "../../../styles/table-layout.scss";

#request {
  margin: 20px 40px -20px 40px;
  text-align: right;

  .question {
    margin-right: 5px;
    font-size: 20px;
    line-height: 20px;
    padding: 6px;
    vertical-align: middle;
    color: #999;
  }
}

.el-alert {
  padding-left: 36px;
  &.dirty {
    border-bottom: 1px solid rgba(0,0,0,0.1);
  }
}

.el-alert ::v-deep {
  .el-alert__title.is-bold {
    font-weight: normal;
  }
  .el-alert__description {
    display: inline-block;
    margin: 0;
    .el-button {
      margin-left: 10px;
    }
  }
}

</style>
